var tabsContainer = document.querySelector('.template-index .feat-coll-withtabs .collection__title .tabs');
var leftArrow = document.querySelector('.template-index .feat-coll-withtabs .collection__title .left-arrow');
var rightArrow = document.querySelector('.template-index .feat-coll-withtabs .collection__title .right-arrow');

if (leftArrow && rightArrow && tabsContainer) {
    // Scroll left on clicking the left arrow
    leftArrow.addEventListener('click', () => {
      tabsContainer.scrollBy({
        left: -200, // Adjust the scroll distance as per your need
        behavior: 'smooth'
      });
    });

    // Scroll right on clicking the right arrow
    rightArrow.addEventListener('click', () => {
      tabsContainer.scrollBy({
        left: 200, // Adjust the scroll distance as per your need
        behavior: 'smooth'
      });
    });
  }

var tabsContainer_prd = document.querySelector('.template-product .shopify-tabs-wrapper .shopify-tabs');
var leftArrow_prd = document.querySelector('.template-product .shopify-tabs-wrapper .left-arrow');
var rightArrow_prd = document.querySelector('.template-product .shopify-tabs-wrapper .right-arrow');
if (leftArrow_prd && rightArrow_prd && tabsContainer_prd) {
    // Scroll left on clicking the left arrow
    leftArrow_prd.addEventListener('click', () => {
      tabsContainer_prd.scrollBy({
        left: -200, // Adjust the scroll distance as per your need
        behavior: 'smooth'
      });
    });

    // Scroll right on clicking the right arrow
    rightArrow_prd.addEventListener('click', () => {
      tabsContainer_prd.scrollBy({
        left: 200, // Adjust the scroll distance as per your need
        behavior: 'smooth'
      });
    });
  }


//Product gallery slider
// var tabsContainer_prd_sideimg = document.querySelector('.template-product .thumbnail-slider .thumbnail-list');
// var upArrow_prd_sideimg = document.querySelector('.template-product .thumbnail-slider .slider-button--prev'); // Up arrow
// var downArrow_prd_sideimg = document.querySelector('.template-product .thumbnail-slider .slider-button--next'); // Down arrow

// if (upArrow_prd_sideimg && downArrow_prd_sideimg && tabsContainer_prd_sideimg) {
    
//     // Scroll up on clicking the up arrow
//     upArrow_prd_sideimg.addEventListener('click', () => {
//         alert('up');
//         tabsContainer_prd_sideimg.animate({
//      scrollTop: -200
//    }, 2000);
//     });

//     // Scroll down on clicking the down arrow
 

// }

//  jQuery('.template-product .thumbnail-slider .slider-button--prev').click(function(){
//     //alert('up');
//     jQuery('.thumbnail-list').animate({
//      scrollTop: -200
//    });
// });

//  jQuery('.template-product .thumbnail-slider .slider-button--next').click(function(){
//     //alert('down');
//     jQuery('.thumbnail-list').animate({
//      scrollTop: 200
//    });
// });
